import type { BlockType } from '@unifyapps/defs/types/block';
import _merge from 'lodash/merge';

/**
 * Merge a TemplateComponent slot-prop override entry onto a child block.
 * The override carries content/appearance DELTAS only; everything else (id,
 * componentType, parent, etc.) is preserved from the authored block. Returns
 * the same `block` reference when no override exists so callers can cheaply
 * skip downstream work.
 *
 * Deep merge: nested objects are merged recursively so a partial override
 * (e.g. `{ style: { color: "blue" } }`) preserves unmentioned authored keys
 * (e.g. `size`) rather than replacing the whole nested object.
 */
export function mergeBlockOverride(block: BlockType, override: BlockType | undefined): BlockType {
  if (!override) return block;

  const overrideContent = override.component.content as Record<string, unknown> | undefined;
  const overrideAppearance = override.component.appearance as Record<string, unknown> | undefined;

  return {
    ...block,
    visibility: _merge({}, block.visibility, override.visibility),
    component: {
      ...block.component,
      content: _merge({}, block.component.content, overrideContent),
      appearance: _merge({}, block.component.appearance, overrideAppearance),
    },
  } as BlockType;
}
